import { render, staticRenderFns } from "./LargeBookForm.vue?vue&type=template&id=3684cfc4&"
import script from "./LargeBookForm.vue?vue&type=script&lang=js&"
export * from "./LargeBookForm.vue?vue&type=script&lang=js&"
import style0 from "./LargeBookForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports